<template>
  <div class="order-recovery-view" />
</template>
<script setup>
import { onMounted } from 'vue';
import { useTitle } from '@vueuse/core';

onMounted(async () => {
    useTitle('Complete your order');
});
</script>
<style lang="scss" scoped>
.order-recovery-view {
  height: 100vh;
}
</style>
